import {useEffect} from "react";
import "./../../utils/Style/component/Stepper.scss";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faCheck} from "@fortawesome/free-solid-svg-icons";
import {useNavigate} from "react-router-dom";

const Stepper = ({currentStep, steps, setSteps, setCurrentStep, visited, setVisited}) => {

    const navigate = useNavigate();

    const selectStep = (step) => {
        if(visited.includes(step-1) || (step === 1)) {
            setCurrentStep(step);
            navigate(`/merchant-enrollment/${step}`);
        }
    }

    useEffect(() => {
        if (currentStep !== 1) {
            setVisited([...visited, currentStep-1]);
        }
    }, [currentStep]);

    return (
        <div id="Stepper">
            <div className="stepper-container">
                <div className="step-indicators">
                    {
                        steps.map((stepObj, index) => (
                        <div className="cont" key={index}>
                            <div
                                className={`step-indicator${currentStep === stepObj.step ? " active" : ""}${visited.includes(stepObj.step) ? " visited" : ""}`}
                                onClick={() => selectStep(stepObj.step)}
                            >
                                {
                                    visited.includes(stepObj.step) ? <FontAwesomeIcon icon={faCheck}></FontAwesomeIcon> : stepObj.step
                                }
                            </div>
                            <p className={`${currentStep === stepObj.step ? " activep" : ""}`} >{stepObj.description}</p>
                            {stepObj.step !== steps.length && <hr />}
                        </div>
                    ))}
                </div>
            </div>
        </div>
    );
};

export default Stepper;
